import { media } from 'shared/lib'
import { ArticleAuthorNote, ArticleAuthorNotes } from 'shared/types/ArticleAuthorNotes'
import styled from 'styled-components'

type AuthorNoteProps = {
  note: ArticleAuthorNote
}

const AuthorNote = ({ note }: AuthorNoteProps) => {
  return (
    <div>
      <NoteTitle data-qa="ArticleAuthorNotesSectionTitle">{note?.title}</NoteTitle>
      <NoteName data-qa="ArticleAuthorNotesSectionName">{note?.name}</NoteName>
    </div>
  )
}

type ArticleAuthorNotesSectionProps = {
  section: ArticleAuthorNotes
}

export const ArticleAuthorNotesSection = ({ section }: ArticleAuthorNotesSectionProps) => {
  if (!section?.subsections || section?.subsections?.length === 0) {
    return null
  }

  return (
    <Container data-qa="ArticleAuthorNotesSectionContainer">
      {section?.subsections?.map((note) => (
        <AuthorNote key={note?.uuid} note={note} />
      ))}
    </Container>
  )
}

const Container = styled.div`
  color: #000;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  margin-bottom: 120px;
  margin-top: 120px;
  width: 100vw;

  ${media.medium`
    margin-bottom: 240px;
    margin-top: 240px;
  `};
`
const NoteName = styled.div`
  color: #000;
  font-family: 'Ivar Text'; /* stylelint-disable-line font-family-no-missing-generic-family-keyword */
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.14px;
  text-align: center;
`
const NoteTitle = styled.div`
  color: #000;
  font-family: 'Helvetica Neue'; /* stylelint-disable-line font-family-no-missing-generic-family-keyword */
  font-size: 12px;
  font-weight: 400;
  line-height: 120%;
  margin-bottom: 4px;
  text-align: center;
  text-transform: uppercase;
`
